import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const WomenEmpowermentListConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/women-empowerment-list",
    component: React.lazy(() => import("./women-empowerment-list")),
  },
];
